import type { PhoneApp } from '../app/phone.js';

export function DevicesPanel({ app }: { app: PhoneApp }) {
  const p = app.devicePrefs.value;
  const d = app.devices.value;
  const set = (patch: Partial<typeof p>): void => void app.setDevicePrefs({ ...p, ...patch });
  const opt = (list: MediaDeviceInfo[], fallback: string) => [
    <option key="" value="">
      {fallback}
    </option>,
    ...list.map((x) => (
      <option key={x.deviceId} value={x.deviceId}>
        {x.label || x.deviceId.slice(0, 8)}
      </option>
    )),
  ];
  return (
    <section class="card" aria-label="Devices">
      <div class="row grow">
        <label>
          Microphone
          <select value={p.mic ?? ''} onChange={(e) => set({ mic: (e.target as HTMLSelectElement).value || null })}>
            {opt(d.mics, 'Default microphone')}
          </select>
        </label>
        <label>
          Speaker
          <select value={p.speaker ?? ''} onChange={(e) => set({ speaker: (e.target as HTMLSelectElement).value || null })}>
            {opt(d.outputs, 'Default speaker')}
          </select>
        </label>
        <label>
          Ringer
          <select value={p.ringer ?? ''} onChange={(e) => set({ ringer: (e.target as HTMLSelectElement).value || null })}>
            {opt(d.outputs, 'Default ringer')}
          </select>
        </label>
      </div>
      <label class="row">
        <input type="checkbox" checked={p.ringAlsoSpeaker} onChange={(e) => set({ ringAlsoSpeaker: (e.target as HTMLInputElement).checked })} /> Also ring on the speaker
      </label>
      <div class="row">
        <button onClick={() => void app.refreshDevices()}>Refresh list</button>
        <button onClick={() => void app.pairHeadset()}>Pair headset (WebHID)</button>
        <span class="sub">{app.hidDevices.value.map((h) => h.productName).join(', ') || 'No headset paired'}</span>
      </div>
    </section>
  );
}
